import { supabase } from '../lib/supabaseClient'

interface SubmitPayload {
  planId: string
  advisorCode?: string
  client: { name: string; email: string }
  riskAnswers: Record<number, number>
  riskProfile: any
}

export async function submitQuestionnaire(payload: SubmitPayload) {
  const { error } = await supabase.functions.invoke('submit_questionnaire', {
    body: payload,
  })
  if (error) throw error
}


